import * as React from 'react';

import { Button, IButtonProps } from '@cian/components';

const styles = require('./pik_button.css');

interface IProps extends IButtonProps {
  pikTheme?: 'blue';
}

export class PikButton extends React.PureComponent<IProps, object> {
  public render() {
    const { pikTheme, buttonStyle: externalStyle, ...props } = this.props;
    const buttonStyles = [styles['button'], pikTheme && styles[pikTheme]].concat(externalStyle);

    return (
      <Button buttonStyle={buttonStyles} {...props}>
        {this.props.children}
      </Button>
    );
  }
}
